"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const get_input_name_1 = __importDefault(require("@App/forms/v2/helpers/get-input-name"));
const CheckboxForm = (props) => {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { mainColor = true, size, label, checked, labelInfo, readonly, children, className } = props;
    const inputName = (0, get_input_name_1.default)(props);
    return (react_1.default.createElement(react_hook_form_1.Controller, { name: inputName, control: control, defaultValue: checked, render: ({ field: { value, onChange, name }, fieldState: { error } }) => (react_1.default.createElement(Checkbox_1.default, { mainColor: mainColor, onClick: onChange, size: size, labelInfo: labelInfo, text: label, checked: !!value, id: name, readonly: readonly, errorMessage: error === null || error === void 0 ? void 0 : error.message, className: className }, children)) }));
};
exports.default = CheckboxForm;
